import SearchEmptyState from './SearchEmptyState.component';

export default SearchEmptyState;
